var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaMlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bc1e5a;}.cls-2,.cls-3{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,5A45,45,0,1,1,5,50,45.05,45.05,0,0,1,50,5m0-5a50,50,0,1,0,50,50A50,50,0,0,0,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.23,71.68l4.52-12.93,12.93-4.52A22.18,22.18,0,0,1,54.23,71.68M28.32,54.23l12.93,4.52,4.52,12.93A22.18,22.18,0,0,1,28.32,54.23M45.77,28.32,41.25,41.25,28.32,45.77A22.18,22.18,0,0,1,45.77,28.32M71.68,45.77,58.75,41.25,54.23,28.32A22.18,22.18,0,0,1,71.68,45.77M50.23,72.08v-22L44.4,55.88,27.92,50.12a.13.13,0,0,1,0-.06H50.23V27.92h.12l5.7,16.31-5.82,5.82H72.09c0,.07,0,.15,0,.22l-16,5.6L50.39,72.07h-.16m27.65-20L83.78,50l-5.9-2.06A28,28,0,0,0,52.06,22.12L50,16.22l-2.06,5.9A28,28,0,0,0,22.12,47.94L16.22,50l5.9,2.06A28,28,0,0,0,47.94,77.88L50,83.78l2.06-5.9A28,28,0,0,0,77.88,52.06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaMlogo);
export default __webpack_public_path__ + "static/media/AAM.logo.a190880a542254a930150c9e34c4c034.svg";
export { ForwardRef as ReactComponent };